import home from './modules/home';
// 重新组织后导出
export default {
  ...home
};
